import * as React from "react";
import * as Icons from "@heroicons/react/24/outline";

type IconProps = React.ComponentPropsWithRef<typeof Icons.Bars3Icon>;

// Re-export all icons with proper React context
export const Bars3Icon = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => {
    return <Icons.Bars3Icon {...props} ref={ref} />;
  }
);

export const XMarkIcon = React.forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => {
    return <Icons.XMarkIcon {...props} ref={ref} />;
  }
);

// Export the icon names for TypeScript
Bars3Icon.displayName = "Bars3Icon";
XMarkIcon.displayName = "XMarkIcon";
